
import { defineComponent, onMounted, reactive, ref } from "vue";
import { AdminTableLayout, ReportTable, ExportButton } from "@/components/Common";

import { useDynamicDialog, useReportTable, useReportTableShowColumn } from "@/hooks";

import { tableColumn } from "./abnormalFilterColum";

import { QueryAbnormalArea, RestrictedArea } from "@/api-server/modules/defaultServer";
import { formatThisMonth, momentFormat } from "@/utils/formatter";
import { ElMessage } from "element-plus";
import { zcatPoint } from "@/utils/utilFuns";
import { useBind } from "../../permission-config/hooks";

export default defineComponent({
  name: "AbnormalFilter",
  components: {
    AdminTableLayout,
    ReportTable,
    ExportButton,
  },

  setup() {
    const { handleBind } = useBind('需要绑定电子面单账号后方可进行限发查询！', true)
    const { getModelUUID, openModel } = useDynamicDialog()
    const formData = reactive({
      address: "",
    });
    let exportForm: any = null
    const { showTableColumn } = useReportTableShowColumn(tableColumn);

    const { loading, tableData, requestTableData, onSearchHandle } =
      useReportTable(QueryAbnormalArea.fetch, formData, () => {
        zcatPoint(["基础设置", "按地址查询", "限发区域"]);
        exportForm = null
        return postData()
      });
    function fmtaddress(addressStr: string) {
      if (addressStr) {
        const searchAdressList = addressStr
          .split("\n")
          .map((item) => item.trim())
          .filter((item) => item !== "");

        if (searchAdressList.length > 300) {
          ElMessage.warning("输入框查询最多支持300条，更多数据可使用Excel导入查询");
          return [];
        }
        return Array.from(new Set(searchAdressList));
      } else {
        return [];
      }
    }

    const postData = (data = formData) => {
      return exportForm ? exportForm : {
        address: fmtaddress(data.address)
      }
    }

    function deleteRepeatOrderNumber() {
      formData.address = Array.from(
        new Set(formData.address.split("\n"))
      ).join("\n");
    }

    const handleExcelImport = async () => {
      const uuid = await getModelUUID(
        "admin/base-setting/abnormal-area/ExcelImport"
      );
      openModel(
        uuid,
        { formData: {} }
      );
    };

    onMounted(handleBind)

    return {
      loading,
      onSearchHandle,
      requestTableData,
      showTableColumn,
      tableData,
      formatThisMonth,
      formData,
      deleteRepeatOrderNumber,
      fmtaddress,
      momentFormat,
      postData,
      handleExcelImport,
    };
  },
});
